module.exports = __webpack_public_path__ + "img/settings4.9df71472.png";